import React from "react";
import Navbar from "../components/Payment/components/Navbar/Navbar";
import ConfirmationStatus from "../components/Confirmation/ConfirmationStatus";

function Confirmation() {
  return (
    <>
      <Navbar />
      <ConfirmationStatus />
    </>
  );
}

export default Confirmation;
